// @flow
import createBoundActionCreators, { createCustomCreator } from "common/actionsBase";
import { selectCompletedIds } from "../selectors";

export const types = {
	SEND_SHOW_COMPLETED: "SEND_SHOW_COMPLETED",
};

export default createBoundActionCreators(types, {
	SEND_SHOW_COMPLETED: createCustomCreator((uploader: Object, dispatch: Function, getState: Function) => {
		const ids = selectCompletedIds(getState());
		uploader.sendShowCompleted(ids);
	}),
});
